export const serverRoutes = {
  ping: 'v2/server/ping',
} as const;
